









import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { PerformanceEntry } from '@/types';

const ftbot = namespace('ftbot');

@Component({})
export default class Performance extends Vue {
  @ftbot.State performanceStats!: PerformanceEntry[];

  private tableFields = [
    { key: 'pair', label: 'Pair' },
    { key: 'profit', label: 'Profit' },
    { key: 'count', label: 'Count' },
  ];
}
